import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';

const MENTIONS_TEASE_TRIGGER = 'nav-mentions-tease';

type MentionsCtaButtonProps = {
  iconSize: number;
};

/**
 * Autotest variant `v_mentions_cta` (C3 in autotest-work/navbar/variants.md):
 * when a non-premium user has unseen mentions, the mentions nav item becomes a
 * direct premium CTA ("See who cited you →") that routes into the checkout
 * funnel with the dedicated `nav-mentions-tease` trigger, instead of the
 * icon→mentions-page→upsell path. Additive — only rendered when
 * `surfaces.mentionsAsCta` is set; control renders the normal mentions item.
 */
const MentionsCtaButton = ({ iconSize }: MentionsCtaButtonProps) => (
  <ImpressionWatcher key="mentions-cta" source={MENTIONS_TEASE_TRIGGER}>
    <IconAnchor
      href={routes.checkout_url({
        feature: 'default',
        trigger: MENTIONS_TEASE_TRIGGER,
        from_navbar: true,
      })}
    >
      <IconContainer>
        <Icon name="format_quote" size={iconSize} />
      </IconContainer>
      <IconLabel>See who cited you →</IconLabel>
    </IconAnchor>
  </ImpressionWatcher>
);

export default MentionsCtaButton;
